module.exports = __webpack_public_path__ + "static/media/azure.af8c30c7.png";